import { configureStore } from '@reduxjs/toolkit'
import timeoutReducer from './timeoutSlice'

export default configureStore({
  reducer: {
    timeout: timeoutReducer
  },
})